import { Body, Skeleton } from '@workramp/ui';
import { FullWidthStack, SkeletonWrapper } from './LearnerAIQuestionAnswerSkeleton.styles';

interface LearnerAIQuestionAnswerSkeletonProps {
  progressMessage?: string | null;
}

export const LearnerAIQuestionAnswerSkeleton = ({ progressMessage }: LearnerAIQuestionAnswerSkeletonProps) => (
  <FullWidthStack size={4}>
    {progressMessage && <Body level="sm">{progressMessage}</Body>}
    <SkeletonWrapper>
      <Skeleton height={15} />
    </SkeletonWrapper>
    <SkeletonWrapper widthPercent={95}>
      <Skeleton height={15} />
    </SkeletonWrapper>
    <SkeletonWrapper>
      <Skeleton height={15} />
    </SkeletonWrapper>
    <SkeletonWrapper widthPercent={70}>
      <Skeleton height={15} />
    </SkeletonWrapper>
  </FullWidthStack>
);
